export function footer_popop() {
  if($('#footer-popup').length) {
    $('#footer-popup-close-btn').click(() => {
      $('#footer-popup').addClass('user-hide');
      let now = new Date();
      let time = now.getTime();
      time += 900 * 1000;
      now.setTime(time);
      document.cookie = `footer_popup=${true}; path=/; expires=${now.toUTCString()}`;

    });

    $(window).scroll(function() {
      let user_scroll_position = $(this).scrollTop() + $(window).height();
      let page_height_half_page = document.body.scrollHeight / 2;
      if(user_scroll_position > page_height_half_page) {
        show_popup();
      }
    });

    setTimeout(function(){
      show_popup();
    }, 60000);
  }
}

function show_popup() {
  if($('#footer-popup').hasClass('hide')) {
    $('#footer-popup').removeClass('hide');
  }
}
